var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdentity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "#10384F",
    stroke: "#10384F",
    strokeWidth: 0.920455,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1 18.5602H18.5602V18.1V17C18.5602 16.7447 18.4143 16.5427 18.3012 16.4175C18.1748 16.2775 18.007 16.1439 17.8201 16.0191C17.4435 15.7677 16.9265 15.5109 16.3294 15.2806C15.1348 14.8199 13.5532 14.4398 12 14.4398C10.4468 14.4398 8.86519 14.8199 7.67063 15.2806C7.07347 15.5109 6.5565 15.7677 6.17994 16.0191C5.993 16.1439 5.82521 16.2775 5.69877 16.4175C5.58567 16.5427 5.43977 16.7447 5.43977 17V18.1V18.5602H5.9H18.1ZM14.5602 8C14.5602 6.58582 13.4142 5.43977 12 5.43977C10.5858 5.43977 9.43977 6.58582 9.43977 8C9.43977 9.41418 10.5858 10.5602 12 10.5602C13.4142 10.5602 14.5602 9.41418 14.5602 8ZM8.46023 8C8.46023 6.04418 10.0442 4.46023 12 4.46023C13.9558 4.46023 15.5398 6.04418 15.5398 8C15.5398 9.95582 13.9558 11.5398 12 11.5398C10.0442 11.5398 8.46023 9.95582 8.46023 8ZM4.46023 17C4.46023 16.504 4.70502 16.0355 5.18667 15.591C5.67144 15.1436 6.36486 14.7522 7.1699 14.4297C8.78071 13.7844 10.7225 13.4602 12 13.4602C13.2775 13.4602 15.2193 13.7844 16.8301 14.4297C17.6351 14.7522 18.3286 15.1436 18.8133 15.591C19.295 16.0355 19.5398 16.504 19.5398 17V19.5398H4.46023V17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentity);
export default __webpack_public_path__ + "static/media/identity.9cfee033bfabf97d3e4a10d7d39b0c11.svg";
export { ForwardRef as ReactComponent };